export const HCP_REACH_COLORS = {
    engaged: '#8C3F7D',
    reached: '#DB97D2',
    notReached: '#EAECF0'
};

const AXIS_TITLE_STYLE = {
    color: '#667085',
    fontSize: '12px',
    fontFamily: 'Inter',
    fontWeight: '500'
};

const AXIS_LABEL_STYLE = {
    color: '#667085',
    fontSize: '12px',
    fontFamily: 'Inter',
    fontWeight: '400'
};

export const HCP_REACH_CHART_OPTIONS = {
    chart: {
        type: 'column',
        backgroundColor: null,
        height: 460
    },
    lang: { noData: 'No data to display' },
    title: { text: null },
    credits: { enabled: false },
    exporting: { enabled: false },
    legend: {
        align: 'center',
        verticalAlign: 'bottom',
        symbolRadius: 2,
        itemStyle: {
            color: '#667085',
            fontFamily: 'Inter',
            fontWeight: '400',
            fontSize: '12px'
        }
    },
    xAxis: {
        lineColor: '#D0D5DD',
        tickLength: 0,
        labels: {
            useHTML: true,
            autoRotation: false,
            rotation: 0,
            style: { ...AXIS_LABEL_STYLE, fontSize: '11px' }
        }
    },
    yAxis: {
        min: 0,
        title: { text: 'HCPs in target list', style: AXIS_TITLE_STYLE },
        gridLineColor: '#EAECF0',
        labels: { style: AXIS_LABEL_STYLE },
        stackLabels: {
            enabled: true,
            style: {
                color: '#344054',
                fontFamily: 'Inter',
                fontSize: '10px',
                fontWeight: '400',
                textOutline: 'none'
            }
        }
    },
    plotOptions: {
        column: {
            stacking: 'normal',
            borderWidth: 0,
            pointPadding: 0.04,
            groupPadding: 0,
            crop: false,
            dataLabels: {
                enabled: true,
                allowOverlap: false,
                crop: false,
                overflow: 'allow',
                style: {
                    fontFamily: 'Inter',
                    fontSize: '10px',
                    fontWeight: '500',
                    textOutline: 'none'
                }
            }
        }
    }
};
